import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import { BeneficiaryGrouping } from './BeneficiaryGrouping';

export const AccountOpeningV2BeneficiaryAllocations = ({ collection, onChange }) => {
  const resourceIndexMap = collection.resources().list().reduce((acc, curr, i) => {
    acc[curr.id()] = i;

    return acc;
  }, {});
  return (
    <FDStack direction={'column'} spacing={4}>
      {collection.meta().field('beneficiaryType').options().list()
        .map((opt) => {
          const resources = collection.resources().list().filter(v => v.attr('beneficiaryType') === opt.attr('id'));
          const prompt = opt.attr('prompt') || 'Unknown';
          const lowercasePrompt = prompt.toLowerCase();
          const totalAllocation = resources.reduce((acc, curr) => acc + +curr.attr('sharePercentage'), 0);
          return (
            <BeneficiaryGrouping
              key={opt.attr('id')}
              onChange={onChange}
              totalAllocation={totalAllocation}
              title={`${prompt} beneficiaries (${totalAllocation}% allocated)`}
              emptyTitle={`No ${lowercasePrompt} beneficiaries.`}
              resources={resources}
              resourceIndexMap={resourceIndexMap}
            />
          );
        })}
    </FDStack>
  );
};

AccountOpeningV2BeneficiaryAllocations.propTypes = {
  collection: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
